import styled from 'styled-components'

export const Styled = {
  Content: styled.div`
    max-width: 34.3rem;
    display: grid;
    gap: 2rem;
    background-color: var(--c-theme-2);
    padding: 2rem;
    border-radius: 1rem;
  `,
}
